export default [
    {
        label: "全部图片",
        id: "allImg",
        active: true,
        childrens: [
            { label: "系统默认", id: "sysDef" },
            { label: "登陆页", id: "loginPage" },
            { label: "首页背景", id: "mainBack" },
            { label: "横幅", id: "hengFu" }
        ]
    }
];


// WEBPACK FOOTER //
// ./goingsrc/vueCom/pageVue/go-img-sel/data/imgDefTypes.js